export default class Hook {
  constructor (trigger, procedure) {
    Object.assign(this, { trigger, procedure })
  }
}
